import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Link } from 'react-router-dom';

import { purple } from 'constants/colors';
import { targetBlank } from 'utils/helpers';

const propTypes = {
    buttonSize: PropTypes.oneOf(['large', 'small']),
    buttonType: PropTypes.oneOf(['primary', 'secondary']),
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
};

const baseStyle = {
    borderRadius: 35,
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: 14,
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    verticalAlign: 'top',
};

const getColors = (type, color, disabled) => {
    let backgroundColor;
    let border = '';
    let cursor = 'pointer';
    let fontColor;

    if (type === 'primary') {
        backgroundColor = color;
        fontColor = '#fff';
    } else if (type === 'secondary') {
        backgroundColor = '#fff';
        border = `1px solid ${color}`;
        fontColor = color;
    }

    if (disabled) {
        backgroundColor = '#aaa';
        cursor = 'not-allowed';
        fontColor = '#fff';
    }

    return {
        backgroundColor,
        border,
        color: fontColor,
        cursor,
    };
};

const getElement = (link) => {
    if (link && link.includes('//')) {
        return (props, children = []) => r.a({ ...props, ...targetBlank(link) }, children);
    } if (link) {
        return (props, children = []) => r(Link, { to: link, ...props }, children);
    }

    return r.span;
};

const getPadding = (size, hasIcon = false) => {
    if (hasIcon) {
        if (size === 'small') {
            return '10px 20px 10px 36px';
        } if (size === 'large') {
            return '15px 35px 15px 51px';
        }
    }

    if (size === 'small') {
        return '10px 20px';
    } if (size === 'large') {
        return '15px 35px';
    }

    return null;
};

const render = ({ props: {
    buttonSize = 'large',
    buttonType = 'primary',
    children,
    className = '',
    color = purple,
    disabled = false,
    href,
    icon,
    label = '',
    onClick = () => {},
    style = {},
} }) => {
    const element = getElement(href);
    const padding = getPadding(buttonSize, icon);
    const colors = getColors(buttonType, color, disabled);
    const combinedStyle = { ...baseStyle, ...colors, padding };

    return (
        element({
            className,
            disabled,
            onClick: (e) => disabled ? e.preventDefault() : onClick(),
            style: { ...combinedStyle, ...style }
        }, [
            r.span({ style: { bottom: 1, left: 10, position: 'absolute' } }, [icon]),
            children || label,
        ])
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/ui/Button/index.js